import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

const PROTECTED_API_SCOPE = environment.auth.scopes;

function isApiRequest(url: string): boolean {
  // Handles both relative (/api/...) and absolute (.../api/...) URLs.
  return /(^|\/)api\//i.test(url);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const cal = inject(CalAngularService);

  return from(cal.getAADToken(PROTECTED_API_SCOPE)).pipe(
    switchMap((tokenResponse) => {
      let tokenString: string | null = null;

      if (typeof tokenResponse === 'string') {
        tokenString = tokenResponse;
      } else if (tokenResponse && typeof tokenResponse === 'object') {
        tokenString = (tokenResponse as { accessToken?: string; token?: string }).accessToken
          ?? (tokenResponse as { accessToken?: string; token?: string }).token
          ?? null;
      }

      if (!tokenString) {
        return next(req);
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenString}`,
        },
      });

      return next(authReq);
    }),
  );
};